module.exports = __webpack_public_path__ + "static/media/sentiment.e1cfca55.svg";